import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import { Select, MenuItem, CircularProgress, Typography } from "@mui/material";
import { TagBadge } from "./TagBadge";
import { TAG_INLINE_OPTIONS } from "../utils/constants";
export const InlineTagDropdown = React.memo(({ tag, onSave, saving, disabled, isDirty }) => {
    const [open, setOpen] = useState(false);
    const [localTag, setLocalTag] = useState(tag || "");
    useEffect(() => { setLocalTag(tag || ""); }, [tag]);
    const handleChange = async (val) => {
        setLocalTag(val);
        setOpen(false);
        await onSave(val || null);
    };
    return (_jsx(Select, { value: localTag, onChange: (e) => handleChange(e.target.value), open: open, onOpen: () => setOpen(true), onClose: () => setOpen(false), displayEmpty: true, size: "small", disabled: saving || disabled, renderValue: (v) => {
            if (saving)
                return _jsx(CircularProgress, { size: 12 });
            if (!v)
                return _jsx(Typography, { className: "all-Font-Sizes", sx: { color: "#667085", fontWeight: 400 }, children: "Tag" });
            return _jsx(TagBadge, { tag: v });
        }, sx: {
            "& .MuiOutlinedInput-notchedOutline": { border: isDirty ? "1.5px solid #f59e0b" : "1px solid #EAECF0" },
            "&:hover .MuiOutlinedInput-notchedOutline": { border: isDirty ? "1.5px solid #f59e0b" : "1px solid #D0D5DD" },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": { border: "1.5px solid #ff008e" },
            borderRadius: "8px",
            minWidth: 100,
            bgcolor: "#fff",
            border: '1px solid #D5D7DA',
            boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
            "& .MuiSelect-select": { py: "6px", px: "12px", display: "flex", alignItems: "center" }
        }, MenuProps: { PaperProps: { sx: { borderRadius: "8px", boxShadow: "0 4px 20px rgba(0,0,0,0.12)", mt: 1 } } }, children: TAG_INLINE_OPTIONS.map(opt => (_jsx(MenuItem, { value: opt.value, className: "all-Font-Sizes", sx: { py: 1, px: 2 }, children: _jsx(TagBadge, { tag: opt.value || null }) }, opt.value))) }));
});
